import React, { FC } from "react";
import { ReferenceField, useRecordContext } from "react-admin";
import DriverWithPhoneField from "./DriverWithPhoneField";
import Tooltip from "@material-ui/core/Tooltip";
import LoopIcon from "@material-ui/icons/Loop";
import { Box } from "@material-ui/core";

interface DriverWithReplacementIconFieldProps {
  label: string;
}

const DriverWithReplacementIconField: FC<
  DriverWithReplacementIconFieldProps
> = () => {
  const record = useRecordContext();

  if (!record) return null;

  const hasReplacement = Boolean(record.replacedDriverIdByAdhocOperator);

  return (
    <Box display="inline-flex" alignItems="center">
      <ReferenceField
        source="driverId"
        reference="drivers"
        link="show"
        emptyText="-"
      >
        <DriverWithPhoneField />
      </ReferenceField>
      {hasReplacement && (
        <Tooltip
          title={`Replaced by Adhoc Driver`}
          style={{ marginLeft: "5px" }}
        >
          <LoopIcon fontSize="small" color="primary" />
        </Tooltip>
      )}
    </Box>
  );
};

export default DriverWithReplacementIconField;
